import CoverText from "./CoverText";

function InfoCover({ page, text, short }) {
    return (
        <div className="row slide-show" style={short ? { height: "78vh" } : {}}>
            <div className="row no-margin">
                <div className="black-filter"></div>

                <img src={`./Images/infopages/${page}/cover/2.jpg`} alt="" className="img-fluid mx-auto d-block slide-pic-2" />
                <img src={`./Images/infopages/${page}/cover/3.jpg`} alt="" className="img-fluid mx-auto d-block slide-pic-3" />
                <img src={`./Images/infopages/${page}/cover/1.jpg`} alt="" className="img-fluid mx-auto d-block slide-pic-1" />

                <CoverText page={page} text={text} short={short} />
            </div>
        </div>
    );
}

export default InfoCover;